/* eslint-disable operator-linebreak */
import React from 'react';
import { segmentEvent } from '../../helpers/sendEvent';

export default function CloseButton({ url, userData }) {
  const goBack = () => {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;
    const isSmallScreen = window.innerWidth <= 768 && window.innerHeight <= 1024;
    const isMobile = isMobileDevice || isTouchDevice || isSmallScreen;

    if (window.location.pathname?.includes('due-payment')) {
      segmentEvent('track', 'past due payment closed', {
        channel: isMobile ? 'mobile' : 'desktop',
        first_name: userData?.first_name,
        last_name: userData?.last_name,
      });
    }

    window.location.href = url;
  };

  return (
    <div className="k-close-wrapper">
      <button className="k-close-btn" type="button" onClick={goBack}>
        Close
      </button>
    </div>
  );
}
